import {combineReducers} from "redux";
import {regionReducer} from "./region/reducer";
import {routeGroupReducer} from "./route-group/reducer";

const reducers = {
  regions: regionReducer,
  routeGroups: routeGroupReducer,
};

export const entityReducer = combineReducers(reducers);

export type EntityState = ReturnType<typeof entityReducer>;
